import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import SubmitFormsStyles from "./SubmitForms.styles"
import TabbedNavigationWithDefinedTitle from "../../../components/tabbednavigation/TabbedNavigationWithDefinedTitle"
import FormsListing from "./FormsListing";
import FormsStatePayroll from "./formslistingstatepayroll/FormsStatePayroll"
import { componentKey, setCurrentTabIndex } from "./SubmitFormsSlice"
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks"
import { useLocation } from "react-router-dom"
import { TAB_PATHS } from "./constants"
import { FEATURE_FLAG } from "../../../featureFlags";

const SubmitForms = () => {

    useGarbageCollector(componentKey)
    const dispatch = useDispatch();
    const location = useLocation();

    const { currentTabIndex } = useSelector(state => state[componentKey])

    useEffect(() => {
        const paths = location.pathname.split("/");
        const currentPath = paths[paths.length - 1];

        let index = 0;

        switch (currentPath) {
            case TAB_PATHS.LISTING:
                index = 0;
                break;
            case TAB_PATHS.STATEPAYROLL:
                index = 1;
                break;
        }

        dispatch(setCurrentTabIndex(index));
    }, [location.pathname])

    const tabListWithTitleObj = [
        {
            title: {
                titleText: "Forms 1099"
            },
            tabBodyComponent: <FormsListing />,
            linkTo: `/${TAB_PATHS.LISTING}`
        },
        ...(FEATURE_FLAG.SHOW_STATE_PAYROLL ? [{
            title: {
                titleText: "State Payroll Forms"
            },
            tabBodyComponent: <FormsStatePayroll />,
            linkTo: `/${TAB_PATHS.STATEPAYROLL}`
        }] : [])
    ];

    return (
        <div>
            <div style={SubmitFormsStyles.gridContainer}>
                <TabbedNavigationWithDefinedTitle
                    tabListWithTitleObj={tabListWithTitleObj}
                    useSeparateUrl={true}
                    sectionPath={"/forms/listing"}
                    activeTabIndex={currentTabIndex}
                    onChangeTabCb={(activeTabIdx) => dispatch(setCurrentTabIndex(activeTabIdx))}
                    unMountChildComponentOnSwitch={true}
                />
            </div>
        </div>
    )
}

export default SubmitForms

